<template>
  <v-container
    grid-list-xl
    fluid
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
      >
        <FilterButtons
          :filters="appliedFilters"
          @filter-removed="removeFilter"
        />

        <CollectionFilters
          :filters="filters"
          :active-filters="appliedFilters"
          @filters-submitted="submitFilters"
          @filters-cleared="clearFilters"
        />
      </v-flex>
      <v-flex xs12>
        <v-data-table
          v-model="selected"
          :loading="loading"
          :headers="headers"
          :items="collection"
          :total-items="meta.totalItems"
          :rows-per-page-text="$t('Rows per page')"
          :rows-per-page-items="meta.rowsPerPageItems"
          :pagination.sync="pagination"
          class="elevation-1"
          item-key="id"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          />

          <template v-slot:items="props">
            <OrderDataTableRow
              :with-requested-delivery="withRequestedDelivery"
              :props="props" />
          </template>

          <template slot="no-data">
            <v-btn
              color="primary"
              @click="clearFilters"
            >
              {{ $t('Reset') }}
            </v-btn>
          </template>
          <template v-slot:pageText="props">
            <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Order from '../components/OrderSingle'
import OrderDataTableRow from '../components/OrderDataTableRow'
import MassActionSelect from '../../../vuetify-console/components/MassActionSelect'
import CollectionFilters from '../../../vuetify-console/components/CollectionFilters'
import FilterButtons from '../../../vuetify-console/components/FilterButtons'

import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapGetters } = createNamespacedHelpers('sales/orders')

export default {
  name: 'OrderList',

  components: {
    OrderDataTableRow,
    Order,
    MassActionSelect,
    CollectionFilters,
    FilterButtons
  },

  actionBar () {
    return {
      title: 'Orders',
      actions: [
        {
          text: 'Create Order',
          event: 'add'
        }
      ]
    }
  },

  data () {
    return {
      withRequestedDelivery: false,
      selected: [],
      searchQuery: ''
    }
  },

  computed: {
    ...mapGetters(['collection', 'loading', 'meta', 'appliedFilters']),

    pagination: {
      get: function () {
        return this.meta
      },
      set: function (value) {
        this.applyMeta(value)
      }
    },

    headers () {
      const headers = [
        { text: this.$t('ID'), value: 'id' },
        { text: this.$t('Name'), value: 'name' },
        { text: this.$t('Order Status'), value: 'order_status' },
        { text: this.$t('Updated At'), value: 'updated_at' },
        { text: this.$t('Item Count'), value: 'items_qty' },
        { text: this.$t('Price'), value: 'summary.total_due.amount' },
        { text: this.$t('Created By'), value: 'created_by.name' },
        { text: this.$t('Created From'), value: 'created_by.from' }
      ]

      if (this.withRequestedDelivery) {
        headers.push({ text: this.$t('Requested Delivery Date'), value: 'requested_delivery' })
      }

      headers.push({ text: this.$t('Created At'), value: 'created_at' })
      return headers
    },

    filters () {
      const filters = [
        { field: 'customer.firstname', type: 'string', label: this.$t('First Name') },
        { field: 'customer.lastname', type: 'string', label: this.$t('Last Name') },
        { field: 'status', type: 'string', label: this.$t('Status') },
        { field: 'created_at', type: 'date', label: this.$t('Created At') },
        { field: 'created_by.name', type: 'string', label: this.$t('Created By') },
        { field: 'created_by.from', type: 'string', label: this.$t('Created From') }
      ]

      if (this.withRequestedDelivery) {
        filters.push({ field: 'requested_delivery', type: 'date', label: this.$t('Requested Delivery Date') })
      }

      return filters
    }
  },

  async mounted () {
    const settings = await this.$http.make('general_settings').find('checkout')
    if (!settings) {
      return
    }
    this.withRequestedDelivery = settings.requesting_delivery_allowed
  },

  methods: {
    ...mapActions(['applyMeta', 'fetchCollection', 'removeFilter', 'clearFilters']),

    setSearchQuery (query) {
      this.searchQuery = query
    },

    onActionAdd () {
      this.$router.push({ name: 'draft-order' })
    },

    submitFilters (filters) {
      this.applyMeta({ filters })
    }
  }
}
</script>

<style scoped>
  .save-fab {
    z-index: 10000000;
  }
</style>
